import { render, staticRenderFns } from "./procedureRegisterSearch.vue?vue&type=template&id=1f7ead54&"
import script from "./procedureRegisterSearch.vue?vue&type=script&lang=js&"
export * from "./procedureRegisterSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports